import React, { useState, useMemo, useRef, useCallback } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getMobileCountriesChartName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_utils/countryName';

const COUNTRIES_TOOLTIP_CONFIG = {
  appendToBody: true,
  extraCssText: 'z-index: 9999999;',
};

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Bar,
    dateType,
    isStackLine,
    barSeriesData,
    lineData = [], // 折线 数据
    regionSegVal = '',
    isNodata,
    chartSegment,
    barOrPieData,
    barNameList,
    topChartsType,
    titleNow,
    chartLoading,
    setChartLoading,
    regionsCountries,
    baseReleaseTime,
    earliestPeriod,
    chartLineLoading,
    startDate,
    endDate,
    lineXAxisData,
  } = props;

  // console.log('Visualis232',props)

  const cardRef = useRef(null);
  const { locale, formatMessage } = useIntlExtend();
  const localizedOthersName = formatMessage({ id: 'dbi_others' });

  // 获取柱状图hooks
  const { barOption } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData,
    titleNow,
    barNameList,
    topChartsType,
    ifNoBarImg: regionSegVal == 'region',
    enableAutoBarWidth: true,
    tooltipExtraConfig: COUNTRIES_TOOLTIP_CONFIG,
    cardWidth: cardRef?.current?.clientWidth,
    chartType,
    imageType: regionSegVal,
    regionSegVal,
    startDate,
    endDate,
  });

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      arr.push({
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: list[i].value,
      });
    }
    return arr;
  };

  const getMetricsList = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const n in list) {
      const nameTemp = getMobileCountriesChartName({
        regionsCountries,
        countryCode: list[n].market,
        regionSegVal,
        fallbackName: list[n].name,
        localizedOthersName,
      });
      const objTemp = {
        cover: list[n].market,
        id: nameTemp,
        name: nameTemp,
        history: getRpdTypeData(list[n].history || []),
      };
      arr.push(objTemp);
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = {};
    for (const n in lineData) {
      arrGameData[lineData[n].metric] = getMetricsList(lineData[n].Country_time_line);
    }
    return arrGameData;
  }, [lineData, regionsCountries, regionSegVal, dateType, localizedOthersName, locale]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: chartSegment,
    topChartsType: 'rpd',
    titleNow,
    chartType,
    setChartLoading,
    isStackLine,
    imageType: regionSegVal,
    baseReleaseTime: showTimeByDateType(baseReleaseTime, dateType?.toLocaleLowerCase()),
    earliestPeriod: showTimeByDateType(earliestPeriod, dateType?.toLocaleLowerCase()),
    shouldMoveTooltipOthersLast: true,
    tooltipOthersNames: ['others', localizedOthersName],
    tooltip: COUNTRIES_TOOLTIP_CONFIG,
    lineXAxisData,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={
            chartType == 'line' || chartType == 'stackedLine' ? chartLineLoading : chartLoading
          }
          barOption={barOption}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
